import React from 'react';

import Link from 'common/Link';

type Props = {
  title: React.ReactNode;
  image: React.ReactNode;
  description: string;
  url: string;
  external?: boolean;
};

const IntegrationBox = ({ title, image, external, description, url }: Props) => {
  if (external) {
    return (
      <li className="directoryItem">
        <a target="_blank" rel="nofollow noopener" href={url}>
          <div className="directoryItemContents">
            {image}
            <div className="text">
              <p className="productName">{title}</p>
              <p className="description">{description}</p>
            </div>
          </div>
        </a>
      </li>
    );
  }
  return (
    <li className="directoryItem">
      <Link to={url}>
        <div className="directoryItemContents">
          {image}
          <div className="text">
            <p className="productName">{title}</p>
            <p className="description">{description}</p>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default IntegrationBox;
